export const RENT_GUIDE_LIST = [
  {
    step: 1,
    title: 'Подготовьте недвижимость к сдаче в аренду',
    slider: [
      {
        image: 'e1cce621de9415e4e06b533c6da914a9.png',
        title: 'Какие документы нужно собрать перед тем, как сдавать квартиру?',
        notice: '5 мин. чтения',
        link: 'https://www.cian.ru/stati-kakie-dokumenty-nuzhno-sobrat-pered-tem-kak-sdavat-kvartiru-332304/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '4bce45411e5da5f2f0dcd60168b4834b.png',
        title: 'Посчитайте расходы при сдаче квартиры в аренду: ремонт, страховка, налоги и другие',
        notice: '4 мин. чтения',
        link: 'https://www.cian.ru/stati-poschitajte-rashody-pri-sdache-kvartiry-v-arendu-remont-strahovka-nalogi-i-drugie-328916/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '91aebaa03faf62dac1b8313968040413.png',
        title: 'С чего начать, если вы хотите сдать квартиру: взвесьте риски',
        notice: '5 мин. чтения',
        link: 'https://www.cian.ru/stati-s-chego-nachat-esli-vy-hotite-sdat-kvartiru-vzveste-riski-328913/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '74d2df08b3812684fa325d64bda98015.png',
        title: 'Как подготовить квартиру к сдаче в аренду',
        notice: '3 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-podgotovit-kvartiru-k-sdache-v-arendu-328898/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'e900e8f2c02fc0d0f67afafd31a892c8.png',
        title: 'Что такое хоумстейджинг и как это работает',
        notice: '15 мин. чтения',
        link: 'https://www.cian.ru/stati-chto-takoe-houmstejdzhing-i-kak-eto-rabotaet-325088/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '1df5ce82f307efd2c2a814479f2d7433.png',
        title: 'Как сдать квартиру с недостатками?',
        notice: '7 мин. чтения',
        link: 'https://www.cian.ru/stati-arenda-kak-sdat-kvartiru-s-nedostatkami-328763/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '14148e1da02d7274b2fc8bad648d3e49.png',
        title: 'Как организовать бесконтактное заселение при сдаче квартиры в аренду',
        notice: '4 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-organizovat-beskontaktnoe-zaselenie-pri-sdache-kvartiry-v-arendu-330997/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '4f76cdeea8c45ab6596809b6f65367e3.png',
        title: 'Бытовая техника: минимальный набор для квартиры под сдачу',
        notice: '3 мин. чтения',
        link: 'https://www.cian.ru/stati-bytovaja-tehnika-minimalnyj-nabor-dlja-kvartiry-pod-sdachu-328895/?cian_source=guide&cian_medium=rent',
      },
    ],
  },
  {
    step: 2,
    title: 'Создайте эффективное объявление',
    slider: [
      {
        image: '676d1ab8e3db74dce7c7190b98c2f728.png',
        title: 'Какие факторы влияют на ставку аренды и как ее определить?',
        notice: '3 мин. чтения',
        link: 'https://www.cian.ru/stati-kakie-faktory-vlijajut-na-stavku-arendy-i-kak-ee-opredelit-328919/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '5d5f9ac8ab81de927f230c80bda150e1.png',
        title: 'Пошаговая инструкция, как разместить объявление на Циан',
        notice: '4 мин. чтения',
        link: 'https://www.cian.ru/stati-poshagovaja-instruktsija-kak-razmestit-objavlenie-na-tsian-332829/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'dc2a15e4bfcf8305247394d102b584e3.png',
        title: 'Как привлечь больше внимания к своему объявлению на Циан?',
        notice: '4 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-privlech-bolshe-vnimanija-k-svoemu-objavleniju-na-tsian-333459/?cian_source=guide&cian_medium=rent',
      },
      {
        image: 'dc2a15e4bfcf8305247394d102b584e3.png',
        title: 'Как составить хорошее описание своей квартиры для сдачи в аренду?',
        notice: '4 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-pravilno-pisat-objavlenie-dlja-sdachi-kvartiry-v-arendu-293271/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '6cde868b86059671fa9bed69f367cf62.png',
        title: 'Как снимать фото и видео для объявления об аренде?',
        notice: '4 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-snimat-foto-i-video-dlja-objavlenija-ob-arende-328854/?cian_source=guide&cian_medium=rent',
      },
    ],
  },
  {
    step: 3,
    title: 'Общайтесь с потенциальными арендаторами',
    slider: [
      {
        image: 'b44641a1b4a028c22c6fb853962183b5.png',
        title: 'Пять правил, как общаться с потенциальным арендатором по телефону и в чатах',
        notice: '4 мин. чтения',
        link: 'https://www.cian.ru/stati-pjat-pravil-kak-obschatsja-s-potentsialnym-arendatorom-po-telefonu-i-v-chatah-328907/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '00fc145219966b6616a3fcf0cd25d998.png',
        title: 'Как оценить надежность арендатора?',
        notice: '5 мин. чтения',
        link: 'https://www.cian.ru/stati-proverka-arendatora-kak-sobstvenniku-otsenit-ego-nadezhnost-332391/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '840f812444b08a876ac894b995152078.png',
        title: 'Какие моменты нужно обсудить с арендатором до заключения договора?',
        notice: '4 мин. чтения',
        link: 'https://www.cian.ru/stati-kakie-momenty-nado-obsudit-s-arendatorom-do-zakljuchenija-dogovora-328922/?cian_source=guide&cian_medium=rent',
      },
    ],
  },
  {
    step: 4,
    title: 'Как заключить договор',
    slider: [
      {
        image: '5184a6e62670c23b35be751d062216d5.png',
        title: 'Как проверить потенциального арендатора и его документы?',
        notice: '2 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-proverit-potentsialnogo-arendatora-i-ego-dokumenty-328900/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '1c2051ab6dcb399b59e6ac58003352a1.png',
        title: 'Как правильно договариваться о задатке?',
        notice: '5 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-oformit-dogovor-zadatka-pri-sdache-zhilja-v-arendu-334357/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '2526f8a903d3c69bdaa6c1ef9b55b205.png',
        title: 'Подготовка документов Чек-лист по юридической стороне подготовки квартиры / дома) + шаблоны договоров?',
        notice: '0 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-podgotovit-kvartiru-k-sdache-v-arendu-334376/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '303febcb2e99f315a5802f34f0e74be0.png',
        title: 'Аренда: кто платит за мелкий ремонт и как возмещать ущерб',
        notice: '4 мин. чтения',
        link: 'https://www.cian.ru/stati-arenda-kto-platit-za-melkij-remont-i-kak-vozmeschat-uscherb-328903/?cian_source=guide&cian_medium=rent',
      },
      {
        image: '37449c1fee20592317c6179775a9da52.png',
        title: 'Как налоговая узнает о сдаче квартиры в аренду и что за это будет',
        notice: '9 мин. чтения',
        link: 'https://www.cian.ru/stati-kak-nalogovaja-uznaet-o-sdache-kvartiry-v-arendu-i-chto-za-eto-budet-330021/?cian_source=guide&cian_medium=rent',
      },
    ],
  },
];
